(function () {
	function handleTopbarSlider() {
		const slides = document.querySelectorAll(".swiper-slide.richtext");

		slides.forEach((slide) => {
			const contentDiv = slide.querySelector(".topbar-content");
			if (!contentDiv) return;

			// Check early access first (higher priority)
			const isEarlyAccess = localStorage.getItem("EarlyAccess") === "true";
			if (isEarlyAccess) {
				const earlyAccessDiv = slide.querySelector(".topbar-early-access");
				if (earlyAccessDiv) {
					contentDiv.innerHTML = earlyAccessDiv.innerHTML;
					return;
				}
			}

			// Check price testing
			const priceTestingVariation = localStorage.getItem("kuru_price_testing");
			if (priceTestingVariation === "variation-1") {
				const variation1Div = slide.querySelector(".topbar-variation-1");
				if (variation1Div) {
					contentDiv.innerHTML = variation1Div.innerHTML;
				}
			} else if (priceTestingVariation === "variation-2") {
				const variation2Div = slide.querySelector(".topbar-variation-2");
				if (variation2Div) {
					contentDiv.innerHTML = variation2Div.innerHTML;
				}
			}
		});
	}

	handleTopbarSlider();
	window.addEventListener("kuru_price_testing", handleTopbarSlider);
	window.addEventListener("storage", handleTopbarSlider);
	document.addEventListener("DOMContentLoaded", handleTopbarSlider);
	document.addEventListener("renderedFullSections", handleTopbarSlider);
})();
